import { Component } from 'vue-property-decorator'
import { HIDE_SNACK, APP_SET_NAVIGATION_STATUS, APP_SET_MENU, APP_RESET_ERROR } from './store/MUTATIONS-TYPES'
import { AppPage } from './interfaces/components'
import { VApp, VBtn, VContainer, VImg, VMain, VRow, VSnackbar, VSpacer } from 'vuetify/lib'
import AppMenu from './components/App/Menu/Menu'
import AppBar from './components/App/AppBar/AppBar'
import { AppErrorDialog } from './components'
import { InstructionsModalProvider } from './components/Providers/InstructionsModalProvider/InstructionsModalProvider'
import PhoneUpdateModal from './components/App/PhoneUpdateModal/PhoneUpdateModal'
import ROUTERS from './router/ROUTERS'
import { ConfigCatHelper } from '@/utils'

@Component({})
export default class App extends AppPage {
	isMenuMouseOver: boolean = false
	isPhoneUpdateModalDisabled: boolean = true

	async mounted() {
		const { commit } = this.$store
		commit(APP_SET_MENU, true)
		this.isPhoneUpdateModalDisabled = await ConfigCatHelper.getIsPhoneUpdateModalDisabled(this.userEmail)
	}

	public render() {
		return (
			<VApp id="app">
				{!this.isPhoneUpdateModalDisabled && <PhoneUpdateModal />}
				<div>
					<AppMenu />
					<AppBar />
				</div>
				<VMain class="ml-0">
					<VContainer fluid={this.isDataTableView} class="fill-height pl-0">
						{this.connectionProblem && (
							<div class="text-center">
								<VImg src="/vectors/icon-no-connection.svg" height="320" contain class="mx-auto" />
								<p class="pa-2 title">
									Eita <br /> Parece que deu algum problema de conexão :( <br /> Nossa equipe de tecnologia já foi avisada do problema
								</p>
								<VBtn onClick={() => window.location.reload()} depressed color="primary">
									Recarregar a página
								</VBtn>
							</div>
						)}
						{!this.connectionProblem && <router-view ref="conteudo" class="layout column fill-height" id="app-container" />}
					</VContainer>
				</VMain>

				<VSnackbar
					multi-line
					vModel={this.snackbar.value}
					scopedSlots={{
						action: () => (
							<VBtn color="primary" onClick={() => this.closeSnackbar()}>
								Fechar
							</VBtn>
						)
					}}
				>
					{this.snackbar.text}
				</VSnackbar>

				<AppErrorDialog />
				<InstructionsModalProvider />
			</VApp>
		)
	}

	// QUANDO FOR FAZER DADOS COMPUTADOS É SÓ CRIAR UMA FUNÇAO E ADICIONAR O PARAMETRO GET A FRENTE
	get userCompleteName() {
		const { state } = this.$store
		return state.user?.name
	}

	get userToken() {
		const { state } = this.$store
		return state.user?.accessToken
	}

	get userEmail() {
		const { state } = this.$store
		return state.user?.email
	}

	get isError() {
		const { state } = this.$store
		return state.app.isError
	}

	get isMenuExpanded() {
		const { state } = this.$store
		return state.app.navigationExpand
	}

	set isError(value: boolean) {
		const { commit } = this.$store
		commit(APP_RESET_ERROR)
	}

	get connectionProblem() {
		const { state } = this.$store
		return state.app.error.connection
	}

	get appErrorMessage() {
		const { state } = this.$store
		return state.app.error.message
	}

	get isLead() {
		const { state } = this.$store
		return state.user?.isLead
	}

	get accountUrl() {
		return import.meta.env.VUE_APP_API_AUTH_HOST as string
	}

	get snackbar() {
		const { state } = this.$store
		return state.app.snackbar
	}

	get lgpdStatus() {
		const { state } = this.$store
		return state.app.lgpdStatus
	}

	toggleNavigation() {
		const { commit } = this.$store
		commit(APP_SET_NAVIGATION_STATUS)
	}

	starTour() {
		const { state } = this.$store

		if (this.isLead && state.app.tour.home) {
			switch (this.$route.name) {
				case ROUTERS.HOME:
				case ROUTERS.CREDITO_IMOBILIARIO.PRE_ANALISE.GERENCIAR:
				case ROUTERS.CREDITO_IMOBILIARIO.PRE_ANALISE.NOVA:
				case ROUTERS.CREDITO_IMOBILIARIO.SIMULADOR.MAIN:
					let tour = this.$refs.conteudo as any
					tour.initTour()
					break
			}
		}
	}

	closeSnackbar() {
		const { commit } = this.$store
		commit(HIDE_SNACK)
	}

	setMouseOverMenu(value: boolean) {
		this.isMenuMouseOver = value
	}
}
